import React from "react";
import {
    Container,
    Grid,
    Card,
    CardActionArea,
    CardContent,
    Typography,
    Box,
    Paper,
} from "@mui/material";
import FMBlogo from "../../../assets/FMBlogo1.png";
import { useLocation, useNavigate } from "react-router-dom";

const CompanyPage = () => {
    const location = useLocation();
    const navigate = useNavigate();

    // companies passed from previous page
    const companies = location.state?.companies || [];

    // handle click
    const handleCompanySelect = (company) => {
        navigate("/user_home", {
            state: { company_id: company.id, company }, // 👈 send both ID & full object
        });
    };

    return (
        <div>
            <Container maxWidth="sm" sx={{ py: 4 }}>
                {/* Logo and Title */}
                <Box textAlign="center" mb={0}>
                    <img src={FMBlogo} alt="Fargerike Logo" width="230" />
                </Box>

                {/* Login info */}
                <Typography variant="body1" textAlign="center" mb={3}>
                    Select company for coupon
                </Typography>

                <Grid container spacing={3} justifyContent="center">
                    {companies.map((company, i) => (
                        <Grid item xs={12} sm={6} key={i}>
                            <Card
                                sx={{
                                    borderRadius: 3,
                                    boxShadow: 3,
                                    "&:hover": {
                                        boxShadow: 6,
                                        transform: "scale(1.03)",
                                    },
                                    transition: "0.3s",
                                }}
                            >
                                <CardActionArea
                                    onClick={() => handleCompanySelect(company)} // 👈 redirect on click
                                >
                                    <CardContent sx={{ textAlign: "center" }}>
                                        <img
                                            src={company.logo || FMBlogo}
                                            alt={company.name}
                                            style={{ maxWidth: 150 }}
                                        />
                                        <Typography variant="h6" mt={1}>
                                            {company.name}
                                        </Typography>
                                    </CardContent>
                                </CardActionArea>
                            </Card>
                        </Grid>
                    ))}
                </Grid>

                <Card sx={{ position: "relative" ,mt: 5}}>
                    <CardContent>
                        <Box
                            className="iframe-container"
                            sx={{ width: "100%", height: "auto" }}
                        >
                            <iframe
                                id="content-iframe"
                                scrolling="no"
                                style={{ border: "none", width: "100%" }}
                            ></iframe>
                        </Box>
                    </CardContent>
                    <Box
                        sx={{
                            position: "absolute",
                            right: 16,
                            top: "50%",
                            transform: "translateY(-50%)",
                        }}
                    >
                        {/* <ArrowForwardIosIcon /> */}
                    </Box>
                </Card>

                {/* Footer Info */}
                <Typography variant="body2">
                    Dette er kun en tjeneste for kunder av Fargerike Majorstuen
                </Typography>
                <Paper>
                    <Box mt={5} textAlign="center">
                        <img src={FMBlogo} alt="Fargerike Logo" width="230" />
                        <Typography variant="body2" color="text.secondary">
                            Sørkedalsveien 10
                            <br />
                            Colosseum Senter
                            <br />
                            Email: butikk@fargerikemajorstuen.no
                            <br />
                            Åpningstider:
                            <br />
                            Mandag – Onsdag 06:30 – 18:00
                            <br />
                            Torsdag – Fredag 06:30 – 19:00
                            <br />
                            Lørdag 08:00 – 16:00
                        </Typography>
                        <br />
                    </Box>
                </Paper>
            </Container>
        </div>
    );
};

export default CompanyPage;
